import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";


const Queues = (props) => {
    // const [ authorized ] = useAuthProvider();
    // const navigate = useNavigate();
    // React.useEffect(() => {
    //     if(!authorized){
    //         return navigate("/home", { replace: true });
    //     }
    // });
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={12} md={7} lg={5} mr="auto" position="relative">
                        Home page for bpm queues.
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Queues;